import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const MaximizeIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M14 3c0-.6.4-1 1-1h6c.6 0 1 .4 1 1v6a1 1 0 0 1-2 0V4h-5a1 1 0 0 1-1-1ZM3 14c.6 0 1 .4 1 1v5h5a1 1 0 0 1 0 2H3a1 1 0 0 1-1-1v-6c0-.6.4-1 1-1Z" />
      <path d="M21.7 2.3c.4.4.4 1 0 1.4l-7 7a1 1 0 0 1-1.4-1.4l7-7a1 1 0 0 1 1.4 0Zm-11 11c.4.4.4 1 0 1.4l-7 7a1 1 0 0 1-1.4-1.4l7-7a1 1 0 0 1 1.4 0Z" />
    </Icon>
  )
);
export default MaximizeIcon;
